import __request__ from "routing/request";
export function getList(sort = "name", page = 1, per_page = 50, query, order = "asc") {
  return __request__("GET", "/authz/roles", null, { "page": page, "per_page": per_page, "query": query, "sort": sort, "order": order }, {
    "Accept": ["application/json"]
  });
}
export function getListForUser(sort = "name", username, page = 1, per_page = 50, query, order = "asc") {
  return __request__("GET", `/authz/roles/user/${username}`, null, { "page": page, "per_page": per_page, "query": query, "sort": sort, "order": order }, {
    "Accept": ["application/json"]
  });
}
export function get(roleId) {
  return __request__("GET", `/authz/roles/${roleId}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function remove(roleId) {
  return __request__("DELETE", `/authz/roles/${roleId}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function removeUser(roleId, username) {
  return __request__("DELETE", `/authz/roles/${roleId}/assignee/${username}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function getUsersForRole(sort = "name", roleId, page = 1, per_page = 50, query, order = "asc") {
  return __request__("GET", `/authz/roles/${roleId}/assignees`, null, { "page": page, "per_page": per_page, "query": query, "sort": sort, "order": order }, {
    "Accept": ["application/json"]
  });
}
export function addUser(roleId, usernames) {
  return __request__("PUT", `/authz/roles/${roleId}/assignees`, usernames, {}, {
    "Accept": ["application/json"]
  });
}
